import React from 'react';
import { IconProps } from '.';

const SvgMonitor = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M2 3v15h9.25v2.75H7v1.5h10v-1.5h-4.25V18H22V3H2Zm18.5 1.5h-17v12h17v-12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgMonitor;
